@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(-920_118_124)
public val Res.string.more_unread: StringResource by lazy {
      StringResource("string:more_unread", "more_unread", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 185615, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 263003, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169138, 35),
      ))
    }

@delegate:ResourceContentHash(1_227_137_100)
public val Res.string.more_workplace_settings: StringResource by lazy {
      StringResource("string:more_workplace_settings", "more_workplace_settings", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 185663, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 263063, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169174, 55),
      ))
    }

@delegate:ResourceContentHash(1_275_528_298)
public val Res.string.my_break_ongoing: StringResource by lazy {
      StringResource("string:my_break_ongoing", "my_break_ongoing", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 185719, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 263147, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169230, 40),
      ))
    }

@delegate:ResourceContentHash(1_975_403_400)
public val Res.string.my_break_row: StringResource by lazy {
      StringResource("string:my_break_row", "my_break_row", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 185764, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 263200, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169271, 40),
      ))
    }

@delegate:ResourceContentHash(-655_362_395)
public val Res.string.my_breaks_title: StringResource by lazy {
      StringResource("string:my_breaks_title", "my_breaks_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 185805, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 263241, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169312, 39),
      ))
    }

@delegate:ResourceContentHash(-1_394_320_596)
public val Res.string.my_checklists_title: StringResource by lazy {
      StringResource("string:my_checklists_title", "my_checklists_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 185849, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 263297, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169352, 51),
      ))
    }

@delegate:ResourceContentHash(1_524_709_883)
public val Res.string.name: StringResource by lazy {
      StringResource("string:name", "name", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 185905, 20),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 263377, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169404, 20),
      ))
    }

@delegate:ResourceContentHash(13_015_120)
public val Res.string.nav_absences: StringResource by lazy {
      StringResource("string:nav_absences", "nav_absences", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 185926, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 263406, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169425, 32),
      ))
    }

@delegate:ResourceContentHash(-749_063_526)
public val Res.string.nav_availability: StringResource by lazy {
      StringResource("string:nav_availability", "nav_availability", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 186020, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 263520, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169503, 40),
      ))
    }

@delegate:ResourceContentHash(-749_063_526)
public val Res.string.nav_availability_tab: StringResource by lazy {
      StringResource("string:nav_availability_tab", "nav_availability_tab", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 185967, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 263459, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169458, 44),
      ))
    }

@delegate:ResourceContentHash(1_897_969_927)
public val Res.string.nav_dashboard: StringResource by lazy {
      StringResource("string:nav_dashboard", "nav_dashboard", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 186069, 29),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 263577, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169544, 33),
      ))
    }

@delegate:ResourceContentHash(1_443_926_545)
public val Res.string.nav_financials: StringResource by lazy {
      StringResource("string:nav_financials", "nav_financials", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 186099, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 263615, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169578, 38),
      ))
    }

@delegate:ResourceContentHash(1_167_338_079)
public val Res.string.nav_home: StringResource by lazy {
      StringResource("string:nav_home", "nav_home", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 186134, 24),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 263658, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169617, 24),
      ))
    }

@delegate:ResourceContentHash(-320_078_606)
public val Res.string.nav_money: StringResource by lazy {
      StringResource("string:nav_money", "nav_money", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 186159, 29),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 263695, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169642, 25),
      ))
    }

@delegate:ResourceContentHash(-1_682_478_265)
public val Res.string.nav_more: StringResource by lazy {
      StringResource("string:nav_more", "nav_more", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 186189, 28),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 263733, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169668, 24),
      ))
    }

@delegate:ResourceContentHash(-1_073_855_439)
public val Res.string.nav_my_shifts: StringResource by lazy {
      StringResource("string:nav_my_shifts", "nav_my_shifts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 186218, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 263766, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169693, 33),
      ))
    }

@delegate:ResourceContentHash(1_806_165_867)
public val Res.string.nav_requests: StringResource by lazy {
      StringResource("string:nav_requests", "nav_requests", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 186256, 32),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 263812, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169727, 32),
      ))
    }

@delegate:ResourceContentHash(275_736_144)
public val Res.string.nav_rosters: StringResource by lazy {
      StringResource("string:nav_rosters", "nav_rosters", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 186289, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 263849, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169760, 31),
      ))
    }

@delegate:ResourceContentHash(-995_427_674)
public val Res.string.nav_schedule: StringResource by lazy {
      StringResource("string:nav_schedule", "nav_schedule", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 186321, 28),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 263889, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169792, 32),
      ))
    }

@delegate:ResourceContentHash(-2_004_102_002)
public val Res.string.nav_team: StringResource by lazy {
      StringResource("string:nav_team", "nav_team", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 186350, 28),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 263926, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169825, 24),
      ))
    }

@delegate:ResourceContentHash(-1_881_922_263)
public val Res.string.note_cap: StringResource by lazy {
      StringResource("string:note_cap", "note_cap", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 186379, 92),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 263963, 208),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169850, 72),
      ))
    }

@delegate:ResourceContentHash(-1_833_975_681)
public val Res.string.note_contractor: StringResource by lazy {
      StringResource("string:note_contractor", "note_contractor", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 186472, 103),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 264172, 159),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169923, 95),
      ))
    }

@delegate:ResourceContentHash(871_921_518)
public val Res.string.note_estimated: StringResource by lazy {
      StringResource("string:note_estimated", "note_estimated", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 186576, 122),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 264332, 178),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 170019, 122),
      ))
    }

@delegate:ResourceContentHash(-429_756_984)
public val Res.string.note_insured_elsewhere: StringResource by lazy {
      StringResource("string:note_insured_elsewhere", "note_insured_elsewhere", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 186699, 102),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 264511, 150),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 170142, 86),
      ))
    }

@delegate:ResourceContentHash(24_617_823)
public val Res.string.note_owner_partner: StringResource by lazy {
      StringResource("string:note_owner_partner", "note_owner_partner", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 186802, 178),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 264662, 274),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 170229, 178),
      ))
    }

@delegate:ResourceContentHash(-109_901_312)
public val Res.string.note_ppk_reduced: StringResource by lazy {
      StringResource("string:note_ppk_reduced", "note_ppk_reduced", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 186981, 104),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 264937, 152),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 170408, 96),
      ))
    }

@delegate:ResourceContentHash(1_061_292_452)
public val Res.string.note_student: StringResource by lazy {
      StringResource("string:note_student", "note_student", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 187086, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 265090, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 170505, 68),
      ))
    }

@delegate:ResourceContentHash(280_956_478)
public val Res.string.note_youth: StringResource by lazy {
      StringResource("string:note_youth", "note_youth", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 187151, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 265191, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 170574, 58),
      ))
    }

@delegate:ResourceContentHash(-745_405_171)
public val Res.string.notif_absence_public_text: StringResource by lazy {
      StringResource("string:notif_absence_public_text", "notif_absence_public_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 187210, 85),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 265306, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 170633, 69),
      ))
    }

@delegate:ResourceContentHash(-1_795_156_108)
public val Res.string.notif_absence_public_title: StringResource by lazy {
      StringResource("string:notif_absence_public_title", "notif_absence_public_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 187296, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 265420, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 170703, 62),
      ))
    }

@delegate:ResourceContentHash(1_876_516_698)
public val Res.string.notif_absence_title: StringResource by lazy {
      StringResource("string:notif_absence_title", "notif_absence_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 187371, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 265519, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 170766, 55),
      ))
    }

@delegate:ResourceContentHash(-1_249_663_913)
public val Res.string.notif_action_availability: StringResource by lazy {
      StringResource("string:notif_action_availability", "notif_action_availability", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 187439, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 265607, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 170822, 45),
      ))
    }

@delegate:ResourceContentHash(1_917_379_008)
public val Res.string.notif_action_marketplace: StringResource by lazy {
      StringResource("string:notif_action_marketplace", "notif_action_marketplace", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 187489, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 265665, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 170868, 48),
      ))
    }

@delegate:ResourceContentHash(1_418_532_648)
public val Res.string.notif_action_review: StringResource by lazy {
      StringResource("string:notif_action_review", "notif_action_review", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 187542, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 265726, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 170917, 35),
      ))
    }

@delegate:ResourceContentHash(-1_073_855_439)
public val Res.string.notif_action_schedule: StringResource by lazy {
      StringResource("string:notif_action_schedule", "notif_action_schedule", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 187582, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 265782, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 170953, 41),
      ))
    }

@delegate:ResourceContentHash(1_552_587_597)
public val Res.string.notif_announcement_title: StringResource by lazy {
      StringResource("string:notif_announcement_title", "notif_announcement_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 187691, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 265915, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 171058, 64),
      ))
    }

@delegate:ResourceContentHash(308_348_854)
public val Res.string.notif_announcement_title_plain: StringResource by lazy {
      StringResource("string:notif_announcement_title_plain", "notif_announcement_title_plain", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 187628, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 265836, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 170995, 62),
      ))
    }

@delegate:ResourceContentHash(-873_593_644)
public val Res.string.notif_availability_reminder_title: StringResource by lazy {
      StringResource("string:notif_availability_reminder_title", "notif_availability_reminder_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 187752, 97),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 265992, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 171123, 85),
      ))
    }

@delegate:ResourceContentHash(-1_057_626_600)
public val Res.string.notif_availability_title: StringResource by lazy {
      StringResource("string:notif_availability_title", "notif_availability_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 187850, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 266130, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 171209, 64),
      ))
    }

@delegate:ResourceContentHash(1_502_978_253)
public val Res.string.notif_borrowed_title: StringResource by lazy {
      StringResource("string:notif_borrowed_title", "notif_borrowed_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 187919, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 266215, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 171274, 72),
      ))
    }

@delegate:ResourceContentHash(39_898_994)
public val Res.string.notif_break_reminder_body: StringResource by lazy {
      StringResource("string:notif_break_reminder_body", "notif_break_reminder_body", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 187984, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 266308, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 171347, 85),
      ))
    }

@delegate:ResourceContentHash(699_009_254)
public val Res.string.notif_break_reminder_title: StringResource by lazy {
      StringResource("string:notif_break_reminder_title", "notif_break_reminder_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 188062, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 266426, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 171433, 58),
      ))
    }

@delegate:ResourceContentHash(579_432_957)
public val Res.string.notif_category_absences: StringResource by lazy {
      StringResource("string:notif_category_absences", "notif_category_absences", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 188198, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 266630, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 171581, 55),
      ))
    }

@delegate:ResourceContentHash(-1_773_170_748)
public val Res.string.notif_category_absences_desc: StringResource by lazy {
      StringResource("string:notif_category_absences_desc", "notif_category_absences_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 188121, 76),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 266501, 128),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 171492, 88),
      ))
    }

@delegate:ResourceContentHash(164_076_435)
public val Res.string.notif_category_announcements: StringResource by lazy {
      StringResource("string:notif_category_announcements", "notif_category_announcements", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 188356, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 266840, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 171727, 56),
      ))
    }

@delegate:ResourceContentHash(1_715_576_242)
public val Res.string.notif_category_announcements_desc: StringResource by lazy {
      StringResource("string:notif_category_announcements_desc", "notif_category_announcements_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 188262, 93),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 266714, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 171637, 89),
      ))
    }

@delegate:ResourceContentHash(-679_452_787)
public val Res.string.notif_category_availability: StringResource by lazy {
      StringResource("string:notif_category_availability", "notif_category_availability", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 188506, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 267034, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 171881, 63),
      ))
    }

@delegate:ResourceContentHash(-162_263_780)
public val Res.string.notif_category_availability_desc: StringResource by lazy {
      StringResource("string:notif_category_availability_desc", "notif_category_availability_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 188409, 96),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 266905, 128),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 171784, 96),
      ))
    }

@delegate:ResourceContentHash(-917_620_120)
public val Res.string.notif_category_checklists: StringResource by lazy {
      StringResource("string:notif_category_checklists", "notif_category_checklists", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 188685, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 267269, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 172048, 49),
      ))
    }

@delegate:ResourceContentHash(-679_593_258)
public val Res.string.notif_category_checklists_desc: StringResource by lazy {
      StringResource("string:notif_category_checklists_desc", "notif_category_checklists_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 188578, 106),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 267126, 142),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 171945, 102),
      ))
    }

@delegate:ResourceContentHash(1_179_730_184)
public val Res.string.notif_category_hiring: StringResource by lazy {
      StringResource("string:notif_category_hiring", "notif_category_hiring", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 188838, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 267470, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 172189, 37),
      ))
    }

@delegate:ResourceContentHash(-37_668_597)
public val Res.string.notif_category_hiring_desc: StringResource by lazy {
      StringResource("string:notif_category_hiring_desc", "notif_category_hiring_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 188735, 102),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 267327, 142),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 172098, 90),
      ))
    }

@delegate:ResourceContentHash(-851_384_100)
public val Res.string.notif_category_no_shows: StringResource by lazy {
      StringResource("string:notif_category_no_shows", "notif_category_no_shows", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 189009, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 267689, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 172336, 43),
      ))
    }

@delegate:ResourceContentHash(856_634_331)
public val Res.string.notif_category_no_shows_desc: StringResource by lazy {
      StringResource("string:notif_category_no_shows_desc", "notif_category_no_shows_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 188884, 124),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 267540, 148),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 172227, 108),
      ))
    }

@delegate:ResourceContentHash(275_736_144)
public val Res.string.notif_category_roster: StringResource by lazy {
      StringResource("string:notif_category_roster", "notif_category_roster", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 189172, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 267912, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 172483, 41),
      ))
    }

@delegate:ResourceContentHash(-462_022_353)
public val Res.string.notif_category_roster_desc: StringResource by lazy {
      StringResource("string:notif_category_roster_desc", "notif_category_roster_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 189073, 98),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 267761, 150),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 172380, 102),
      ))
    }

@delegate:ResourceContentHash(-1_922_641_553)
public val Res.string.notif_category_swaps: StringResource by lazy {
      StringResource("string:notif_category_swaps", "notif_category_swaps", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 189320, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 268132, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 172623, 64),
      ))
    }

@delegate:ResourceContentHash(-753_748_838)
public val Res.string.notif_category_swaps_desc: StringResource by lazy {
      StringResource("string:notif_category_swaps_desc", "notif_category_swaps_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 189214, 105),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 267962, 169),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 172525, 97),
      ))
    }

@delegate:ResourceContentHash(694_285_019)
public val Res.string.notif_channel_general: StringResource by lazy {
      StringResource("string:notif_channel_general", "notif_channel_general", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 189381, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 268217, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 172688, 57),
      ))
    }

@delegate:ResourceContentHash(-2_016_432_121)
public val Res.string.notif_checklist_overdue_title: StringResource by lazy {
      StringResource("string:notif_checklist_overdue_title", "notif_checklist_overdue_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 189435, 101),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 268287, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 172746, 81),
      ))
    }

@delegate:ResourceContentHash(480_458_171)
public val Res.string.notif_checklist_reminder_title: StringResource by lazy {
      StringResource("string:notif_checklist_reminder_title", "notif_checklist_reminder_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 189537, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 268405, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 172828, 78),
      ))
    }

@delegate:ResourceContentHash(1_652_332_115)
public val Res.string.notif_claim_approved_title: StringResource by lazy {
      StringResource("string:notif_claim_approved_title", "notif_claim_approved_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 189620, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 268508, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 172907, 66),
      ))
    }

@delegate:ResourceContentHash(-2_012_473_737)
public val Res.string.notif_claim_pending_title: StringResource by lazy {
      StringResource("string:notif_claim_pending_title", "notif_claim_pending_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 189699, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 268603, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 172974, 69),
      ))
    }

@delegate:ResourceContentHash(65_655_846)
public val Res.string.notif_claim_rejected_title: StringResource by lazy {
      StringResource("string:notif_claim_rejected_title", "notif_claim_rejected_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 189769, 86),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 268685, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 173044, 62),
      ))
    }

@delegate:ResourceContentHash(-1_588_798_184)
public val Res.string.notif_course_assigned_title: StringResource by lazy {
      StringResource("string:notif_course_assigned_title", "notif_course_assigned_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 189856, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 268764, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 173107, 67),
      ))
    }

@delegate:ResourceContentHash(124_732_928)
public val Res.string.notif_direct_title: StringResource by lazy {
      StringResource("string:notif_direct_title", "notif_direct_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 189932, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 268876, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 173175, 66),
      ))
    }

@delegate:ResourceContentHash(-2_086_618_643)
public val Res.string.notif_due: StringResource by lazy {
      StringResource("string:notif_due", "notif_due", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 190007, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 268971, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 173242, 29),
      ))
    }

@delegate:ResourceContentHash(654_011_387)
public val Res.string.notif_marketplace_title: StringResource by lazy {
      StringResource("string:notif_marketplace_title", "notif_marketplace_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 190041, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 269013, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 173272, 63),
      ))
    }

@delegate:ResourceContentHash(2_033_817_813)
public val Res.string.notif_month_line: StringResource by lazy {
      StringResource("string:notif_month_line", "notif_month_line", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 190117, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 269125, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 173336, 36),
      ))
    }

@delegate:ResourceContentHash(-1_898_620_311)
public val Res.string.notif_new_applicant_title: StringResource by lazy {
      StringResource("string:notif_new_applicant_title", "notif_new_applicant_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 190154, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 269162, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 173373, 61),
      ))
    }

@delegate:ResourceContentHash(813_183_631)
public val Res.string.notif_no_show_title: StringResource by lazy {
      StringResource("string:notif_no_show_title", "notif_no_show_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 190224, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 269256, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 173435, 55),
      ))
    }

@delegate:ResourceContentHash(387_961_367)
public val Res.string.notif_note: StringResource by lazy {
      StringResource("string:notif_note", "notif_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 190300, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 269340, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 173491, 34),
      ))
    }

@delegate:ResourceContentHash(-594_680_607)
public val Res.string.notif_now_public_title: StringResource by lazy {
      StringResource("string:notif_now_public_title", "notif_now_public_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 190339, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 269391, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 173526, 74),
      ))
    }

@delegate:ResourceContentHash(-961_328_713)
public val Res.string.notif_ohs_confirmation_body: StringResource by lazy {
      StringResource("string:notif_ohs_confirmation_body", "notif_ohs_confirmation_body", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 190410, 107),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 269470, 175),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 173601, 95),
      ))
    }

@delegate:ResourceContentHash(-1_629_297_785)
public val Res.string.notif_ohs_confirmation_title: StringResource by lazy {
      StringResource("string:notif_ohs_confirmation_title", "notif_ohs_confirmation_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 190518, 84),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 269646, 128),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 173697, 76),
      ))
    }

@delegate:ResourceContentHash(1_864_608_486)
public val Res.string.notif_on_behalf_title: StringResource by lazy {
      StringResource("string:notif_on_behalf_title", "notif_on_behalf_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 190603, 89),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 269775, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 173774, 69),
      ))
    }

@delegate:ResourceContentHash(200_722_252)
public val Res.string.notif_open_shifts_count: StringResource by lazy {
      StringResource("string:notif_open_shifts_count", "notif_open_shifts_count", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 190693, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 269885, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 173844, 55),
      ))
    }

@delegate:ResourceContentHash(-600_917_596)
public val Res.string.notif_open_shifts_title: StringResource by lazy {
      StringResource("string:notif_open_shifts_title", "notif_open_shifts_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 190749, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 269957, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 173900, 59),
      ))
    }

@delegate:ResourceContentHash(518_186_073)
public val Res.string.notif_review_title: StringResource by lazy {
      StringResource("string:notif_review_title", "notif_review_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 190813, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 270061, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 173960, 58),
      ))
    }

@delegate:ResourceContentHash(1_780_628_111)
public val Res.string.notif_roster_published_title: StringResource by lazy {
      StringResource("string:notif_roster_published_title", "notif_roster_published_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 190876, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 270140, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 174019, 60),
      ))
    }

@delegate:ResourceContentHash(1_863_670_653)
public val Res.string.notif_roster_shifts_count: StringResource by lazy {
      StringResource("string:notif_roster_shifts_count", "notif_roster_shifts_count", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 190941, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 270229, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 174080, 57),
      ))
    }

@delegate:ResourceContentHash(576_774_623)
public val Res.string.notif_roster_updated_title: StringResource by lazy {
      StringResource("string:notif_roster_updated_title", "notif_roster_updated_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 190999, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 270299, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 174138, 54),
      ))
    }

@delegate:ResourceContentHash(-789_893_108)
public val Res.string.notif_settings_intro: StringResource by lazy {
      StringResource("string:notif_settings_intro", "notif_settings_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 191062, 232),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 270374, 324),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 174193, 176),
      ))
    }

@delegate:ResourceContentHash(-1_834_727_521)
public val Res.string.notif_settings_title: StringResource by lazy {
      StringResource("string:notif_settings_title", "notif_settings_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 191295, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 270699, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 174370, 56),
      ))
    }

@delegate:ResourceContentHash(-987_479_231)
public val Res.string.notif_shift_line: StringResource by lazy {
      StringResource("string:notif_shift_line", "notif_shift_line", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 191356, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 270788, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 174427, 48),
      ))
    }

@delegate:ResourceContentHash(1_277_688_373)
public val Res.string.notif_shift_note_title: StringResource by lazy {
      StringResource("string:notif_shift_note_title", "notif_shift_note_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 191405, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 270837, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 174476, 54),
      ))
    }

@delegate:ResourceContentHash(-1_024_614_658)
public val Res.string.notif_taken_by_title: StringResource by lazy {
      StringResource("string:notif_taken_by_title", "notif_taken_by_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 191468, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 270924, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 174531, 60),
      ))
    }

@delegate:ResourceContentHash(2_109_836_338)
public val Res.string.notif_trial_emails: StringResource by lazy {
      StringResource("string:notif_trial_emails", "notif_trial_emails", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 191665, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 271193, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 174708, 66),
      ))
    }

@delegate:ResourceContentHash(-1_118_888_597)
public val Res.string.notif_trial_emails_desc: StringResource by lazy {
      StringResource("string:notif_trial_emails_desc", "notif_trial_emails_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 191537, 127),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 271001, 191),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 174592, 115),
      ))
    }

@delegate:ResourceContentHash(-689_852_712)
public val Res.string.notification_open: StringResource by lazy {
      StringResource("string:notification_open", "notification_open", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 191744, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 271312, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 174775, 33),
      ))
    }

@delegate:ResourceContentHash(616_271_692)
public val Res.string.notification_takeover_title: StringResource by lazy {
      StringResource("string:notification_takeover_title", "notification_takeover_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 191782, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 271362, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 174809, 87),
      ))
    }

@delegate:ResourceContentHash(1_711_363_754)
public val Res.string.notifications_earlier: StringResource by lazy {
      StringResource("string:notifications_earlier", "notifications_earlier", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 191858, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 271470, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 174897, 41),
      ))
    }

@delegate:ResourceContentHash(-778_102_959)
public val Res.string.notifications_empty: StringResource by lazy {
      StringResource("string:notifications_empty", "notifications_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 191908, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 271516, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 174939, 55),
      ))
    }

@delegate:ResourceContentHash(315_222_230)
public val Res.string.notifications_mark_all: StringResource by lazy {
      StringResource("string:notifications_mark_all", "notifications_mark_all", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 191960, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 271596, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 174995, 54),
      ))
    }

@delegate:ResourceContentHash(-1_939_820_506)
public val Res.string.notifications_new: StringResource by lazy {
      StringResource("string:notifications_new", "notifications_new", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 192035, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 271695, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 175050, 29),
      ))
    }

@delegate:ResourceContentHash(1_943_310_891)
public val Res.string.number_invalid: StringResource by lazy {
      StringResource("string:number_invalid", "number_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 192069, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 271733, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 175080, 62),
      ))
    }

@delegate:ResourceContentHash(626_005_869)
public val Res.string.occasion_child_birth: StringResource by lazy {
      StringResource("string:occasion_child_birth", "occasion_child_birth", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 192140, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 271824, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 175143, 64),
      ))
    }

@delegate:ResourceContentHash(2_092_490_133)
public val Res.string.occasion_child_wedding: StringResource by lazy {
      StringResource("string:occasion_child_wedding", "occasion_child_wedding", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 192205, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 271913, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 175208, 66),
      ))
    }

@delegate:ResourceContentHash(980_924_086)
public val Res.string.occasion_death_close: StringResource by lazy {
      StringResource("string:occasion_death_close", "occasion_death_close", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 192268, 132),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 272000, 236),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 175275, 144),
      ))
    }

@delegate:ResourceContentHash(2_050_921_877)
public val Res.string.occasion_death_other: StringResource by lazy {
      StringResource("string:occasion_death_other", "occasion_death_other", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 192401, 256),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 272237, 372),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 175420, 180),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString23Resources(map: MutableMap<String, StringResource>) {
  map.put("more_unread", Res.string.more_unread)
  map.put("more_workplace_settings", Res.string.more_workplace_settings)
  map.put("my_break_ongoing", Res.string.my_break_ongoing)
  map.put("my_break_row", Res.string.my_break_row)
  map.put("my_breaks_title", Res.string.my_breaks_title)
  map.put("my_checklists_title", Res.string.my_checklists_title)
  map.put("name", Res.string.name)
  map.put("nav_absences", Res.string.nav_absences)
  map.put("nav_availability", Res.string.nav_availability)
  map.put("nav_availability_tab", Res.string.nav_availability_tab)
  map.put("nav_dashboard", Res.string.nav_dashboard)
  map.put("nav_financials", Res.string.nav_financials)
  map.put("nav_home", Res.string.nav_home)
  map.put("nav_money", Res.string.nav_money)
  map.put("nav_more", Res.string.nav_more)
  map.put("nav_my_shifts", Res.string.nav_my_shifts)
  map.put("nav_requests", Res.string.nav_requests)
  map.put("nav_rosters", Res.string.nav_rosters)
  map.put("nav_schedule", Res.string.nav_schedule)
  map.put("nav_team", Res.string.nav_team)
  map.put("note_cap", Res.string.note_cap)
  map.put("note_contractor", Res.string.note_contractor)
  map.put("note_estimated", Res.string.note_estimated)
  map.put("note_insured_elsewhere", Res.string.note_insured_elsewhere)
  map.put("note_owner_partner", Res.string.note_owner_partner)
  map.put("note_ppk_reduced", Res.string.note_ppk_reduced)
  map.put("note_student", Res.string.note_student)
  map.put("note_youth", Res.string.note_youth)
  map.put("notif_absence_public_text", Res.string.notif_absence_public_text)
  map.put("notif_absence_public_title", Res.string.notif_absence_public_title)
  map.put("notif_absence_title", Res.string.notif_absence_title)
  map.put("notif_action_availability", Res.string.notif_action_availability)
  map.put("notif_action_marketplace", Res.string.notif_action_marketplace)
  map.put("notif_action_review", Res.string.notif_action_review)
  map.put("notif_action_schedule", Res.string.notif_action_schedule)
  map.put("notif_announcement_title", Res.string.notif_announcement_title)
  map.put("notif_announcement_title_plain", Res.string.notif_announcement_title_plain)
  map.put("notif_availability_reminder_title", Res.string.notif_availability_reminder_title)
  map.put("notif_availability_title", Res.string.notif_availability_title)
  map.put("notif_borrowed_title", Res.string.notif_borrowed_title)
  map.put("notif_break_reminder_body", Res.string.notif_break_reminder_body)
  map.put("notif_break_reminder_title", Res.string.notif_break_reminder_title)
  map.put("notif_category_absences", Res.string.notif_category_absences)
  map.put("notif_category_absences_desc", Res.string.notif_category_absences_desc)
  map.put("notif_category_announcements", Res.string.notif_category_announcements)
  map.put("notif_category_announcements_desc", Res.string.notif_category_announcements_desc)
  map.put("notif_category_availability", Res.string.notif_category_availability)
  map.put("notif_category_availability_desc", Res.string.notif_category_availability_desc)
  map.put("notif_category_checklists", Res.string.notif_category_checklists)
  map.put("notif_category_checklists_desc", Res.string.notif_category_checklists_desc)
  map.put("notif_category_hiring", Res.string.notif_category_hiring)
  map.put("notif_category_hiring_desc", Res.string.notif_category_hiring_desc)
  map.put("notif_category_no_shows", Res.string.notif_category_no_shows)
  map.put("notif_category_no_shows_desc", Res.string.notif_category_no_shows_desc)
  map.put("notif_category_roster", Res.string.notif_category_roster)
  map.put("notif_category_roster_desc", Res.string.notif_category_roster_desc)
  map.put("notif_category_swaps", Res.string.notif_category_swaps)
  map.put("notif_category_swaps_desc", Res.string.notif_category_swaps_desc)
  map.put("notif_channel_general", Res.string.notif_channel_general)
  map.put("notif_checklist_overdue_title", Res.string.notif_checklist_overdue_title)
  map.put("notif_checklist_reminder_title", Res.string.notif_checklist_reminder_title)
  map.put("notif_claim_approved_title", Res.string.notif_claim_approved_title)
  map.put("notif_claim_pending_title", Res.string.notif_claim_pending_title)
  map.put("notif_claim_rejected_title", Res.string.notif_claim_rejected_title)
  map.put("notif_course_assigned_title", Res.string.notif_course_assigned_title)
  map.put("notif_direct_title", Res.string.notif_direct_title)
  map.put("notif_due", Res.string.notif_due)
  map.put("notif_marketplace_title", Res.string.notif_marketplace_title)
  map.put("notif_month_line", Res.string.notif_month_line)
  map.put("notif_new_applicant_title", Res.string.notif_new_applicant_title)
  map.put("notif_no_show_title", Res.string.notif_no_show_title)
  map.put("notif_note", Res.string.notif_note)
  map.put("notif_now_public_title", Res.string.notif_now_public_title)
  map.put("notif_ohs_confirmation_body", Res.string.notif_ohs_confirmation_body)
  map.put("notif_ohs_confirmation_title", Res.string.notif_ohs_confirmation_title)
  map.put("notif_on_behalf_title", Res.string.notif_on_behalf_title)
  map.put("notif_open_shifts_count", Res.string.notif_open_shifts_count)
  map.put("notif_open_shifts_title", Res.string.notif_open_shifts_title)
  map.put("notif_review_title", Res.string.notif_review_title)
  map.put("notif_roster_published_title", Res.string.notif_roster_published_title)
  map.put("notif_roster_shifts_count", Res.string.notif_roster_shifts_count)
  map.put("notif_roster_updated_title", Res.string.notif_roster_updated_title)
  map.put("notif_settings_intro", Res.string.notif_settings_intro)
  map.put("notif_settings_title", Res.string.notif_settings_title)
  map.put("notif_shift_line", Res.string.notif_shift_line)
  map.put("notif_shift_note_title", Res.string.notif_shift_note_title)
  map.put("notif_taken_by_title", Res.string.notif_taken_by_title)
  map.put("notif_trial_emails", Res.string.notif_trial_emails)
  map.put("notif_trial_emails_desc", Res.string.notif_trial_emails_desc)
  map.put("notification_open", Res.string.notification_open)
  map.put("notification_takeover_title", Res.string.notification_takeover_title)
  map.put("notifications_earlier", Res.string.notifications_earlier)
  map.put("notifications_empty", Res.string.notifications_empty)
  map.put("notifications_mark_all", Res.string.notifications_mark_all)
  map.put("notifications_new", Res.string.notifications_new)
  map.put("number_invalid", Res.string.number_invalid)
  map.put("occasion_child_birth", Res.string.occasion_child_birth)
  map.put("occasion_child_wedding", Res.string.occasion_child_wedding)
  map.put("occasion_death_close", Res.string.occasion_death_close)
  map.put("occasion_death_other", Res.string.occasion_death_other)
}
